// tr: every area, merged. One file per area (same names as messages/*.ts).
import type { Dict } from "../index";
import hub from "./hub";
import nav from "./nav";
import paywall from "./paywall";
import pricing from "./pricing";
import studio from "./studio";
import studioOptions from "./studioOptions";
import auth from "./auth";
import checkout from "./checkout";
import upsell from "./upsell";
import home from "./home";
import voice from "./voice";
import library from "./library";
import train from "./train";

const all: Dict = Object.assign(
  {},
  hub,
  nav,
  paywall,
  pricing,
  studio,
  studioOptions,
  auth,
  checkout,
  upsell,
  home,
  voice,
  library,
  train,
);
export default all;
